
<template>
  <div class="registry">
    <div class="content" :style="'background-image:url('+backimg_register+')'">
      <div class="header__title">{{ $t('register.zcym01') }}</div>
      <div class="notice-line">
        <div>{{ $t('register.zcym02') }}</div>
        <div class="main" @click="toLogin">{{ $t('register.zcym03') }}</div>
      </div>
      <van-form class="form" @submit="onSubmit">
        <van-field
          v-model="form.loginname"
          autocomplete="off"
          clearable
          name="账号"
          label=""
          :placeholder="$t('register.zcym04')"
          :rules="[
            {
              required: true,
            }
          ]"
        ><template #left-icon>
          <div class="cell_icon1"></div>
        </template></van-field>
        <van-field
          v-model="form.loginpwd"
          autocomplete="off"
          type="password"
          center
          clearable
          name="密码"
          label=""
          :placeholder="$t('register.zcym05')"
          :rules="[
            { required: true,
            },{pattern:/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,20}$/
               ,message:$t('register.zcym11'),trigger:'onBlur'}
          ]"
        ><template #left-icon>
          <div class="cell_icon2"></div>
        </template></van-field>
        <van-field
          v-model="form.password2"
          autocomplete="off"
          type="password"
          center
          clearable
          name="密码"
          label=""
          :placeholder="$t('register.zcym06')"
          :rules="[
            { required: true
            },{pattern:/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,20}$/
               ,message:$t('register.zcym11'),trigger:'onBlur'}
          ]"
        ><template #left-icon>
          <div class="cell_icon2"></div>
        </template></van-field>
        <div class="invite-code-wrap">
          <van-field
            v-model="form.yqcode"
            class="invite-code-field"
            autocomplete="off"
            type="text"
            center
            clearable
            name="邀请码"
            label=""
            :placeholder="yqPlaceholderVisible ? '' : $t('register.zcym07')"
            :disabled="hasCode"
            :rules="[
              { required: false
              }
            ]"
            @focus="yqFocused = true"
            @blur="yqFocused = false"
          ><template #left-icon>
            <div class="cell_icon4"></div>
          </template></van-field>
          <div v-if="yqPlaceholderVisible" class="invite-code-placeholder" @click="focusInviteCode">
            <span class="invite-code-text">{{ $t('register.zcym07') }}</span>
            <span class="invite-optional-tag">{{ $t('register.zcym13') }}</span>
          </div>
        </div>
        <div v-if="showCaptcha" id="cap_iframe"></div>
        <div style="margin-top: 2vh;">
          <!-- :disabled="disabled" -->
          <van-button
            class="submit_btn"
            block
            :loading="loading"
            type="info"
            :loading-text="$t('register.zcym10')"
            native-type="submit"
          >{{ $t('register.zcym08') }}</van-button>
        </div>
      </van-form>
      <div class="notice-line">
        <div class="main" style="margin: auto;" @click="$emit('showService')">{{ $t('register.zcym09') }}</div>
      </div>

    </div>
    <div class="close-icon" name="cross" @click="$emit('close')" />
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'
import { setRegistry, getUcodeByhbid, getUToken } from '@/api/user'
import checkedBox from '@/assets/portal/auth/复选框_s@2x.webp'
import checkedBoxBlackGold from '@/assets/blackgold/复选框_s备份@2x.webp'
export default {
  name: 'Login',
  data() {
    return {
      checkedBox: process.env.VUE_APP_BASE_THEME ? checkedBoxBlackGold : checkedBox,
      disabled: true,
      showCaptcha: true,
      form: {
        loginname: undefined,
        loginpwd: undefined,
        yqcode: undefined,
        lang:localStorage.lang
      },
      loading: false,
      registryVisible: false,
      isRememberPassword: true,
      hasCode: false,
      yqFocused: false,
      pattern: '^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,20}$',
      backimg_register: ''
    }
  },
  computed: {
    yqPlaceholderVisible() {
      return !this.hasCode && !this.yqFocused && !this.form.yqcode
    }
  },
  watch: {
    // $route: {
    //   handler(route) {
    //     this.redirect = (route.query && route.query.redirect) || process.env.VUE_APP_BASE_PATH
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.backimg_register = this.$store.getters.sysInfo.backimg_register
  },
  async mounted() {
    if (this.$route.query.hbid) {
      getUcodeByhbid({ hbid: this.$route.query.hbid }).then((res) => {
        this.form.yqcode = res.ucode
        this.hasCode = true
      })
    } else if (this.$route.query.upcode) {
      this.form.yqcode = this.$route.query.upcode
      this.hasCode = true
    } else {
      this.form.yqcode = ''
      this.hasCode = false
    }
    // const script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = 'https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js'
    // if (!document.querySelector(`script[src="${script.src}"]`)) {
    //     document.body.appendChild(script);
    // }
    // script.onload = async () => {
      this.setCaptcha()
        // try {
        //   const getUTokenRes = await getUToken()
        //   const CaptchaAppId = getUTokenRes.CaptchaAppId
        //   if(CaptchaAppId){
        //     var captcha = new TencentCaptcha(document.getElementById('cap_iframe'), CaptchaAppId, this.callback, {"enableAutoCheck":true});
        //     captcha.show();
        //   }else{
        //     this.disabled=false
        //   }
        // } catch (error) {
        //   this.loadErrorCallback();
        // }
    // }
  },
  methods: {
    focusInviteCode() {
      const input = this.$el.querySelector('.invite-code-field input')
      if (input) input.focus()
    },
    async setCaptcha() {
      this.showCaptcha = true
      await this.$nextTick()
      try {
        const getUTokenRes = await getUToken()
        const CaptchaAppId = getUTokenRes.CaptchaAppId
        if (CaptchaAppId) {
          var captcha = new TencentCaptcha(document.getElementById('cap_iframe'), CaptchaAppId, this.callback, { 'enableAutoCheck': true })
          captcha.show()
        } else {
          this.disabled = false
        }
      } catch (error) {
        this.loadErrorCallback()
      }
    },
    // 定义回调函数
    callback(res) {
        // 第一个参数传入回调结果，结果如下：
        // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
        // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
        // CaptchaAppId       String    验证码应用ID。
        // bizState    Any       自定义透传参数。
        // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
        console.log('callback:', res);
        // res（用户主动关闭验证码）= {ret: 2, ticket: null}
        // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
        // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
        // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
        if (res.ret === 0) {
            this.form.ticket=res.ticket
            this.form.randstr=res.randstr
            this.disabled=false
            // 复制结果至剪切板
            var str = '【randstr】->【' + res.randstr + '】      【ticket】->【' + res.ticket + '】';
            var ipt = document.createElement('input');
            ipt.value = str;
            document.body.appendChild(ipt);
            ipt.select();
            document.execCommand("Copy");
            document.body.removeChild(ipt);
            // alert('1. 返回结果（randstr、ticket）已复制到剪切板，ctrl+v 查看。\n2. 打开浏览器控制台，查看完整返回结果。');
        }
        document.getElementsByClassName('tencent-captcha-dy__robot-checkBox-img-done')[0].src = this.checkedBox
    },

    // 定义验证码js加载错误处理函数
    loadErrorCallback() {
      var appid = 'CaptchaAppId';
       // 生成容灾票据或自行做其它处理
      var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: 0,
        randstr: '@'+ Math.random().toString(36).substr(2),
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error',
      });
    },
    toLogin() {
      // this.$store
      //   .dispatch('user/login', this.form)
      //   .then((res) => {
      //     this.$toast('注册登录成功')
      //     this.$emit('closeLogin')
      //   })
      this.$emit('toLogin', 1)
      // this.$router.push({
      //   path
      // })
    },
    // 密码校验
    checkPassword(password) {
      const reg = /^(\w){6,20}$/
      if (reg.test(password)) {
        return true
      }
      return false
    },
    // 获取图形验证码
    getVerifyCode() {

    },
    // 提交
    onSubmit() {
      if(this.disabled){
        this.$toast.fail('请勾选我是人类完成验证')
        return
      }
      const { loginpwd, password2 } = this.form
      if (loginpwd !== password2) {
        this.$toast.fail(this.$t('register.zcym12'))
        return
      }
      this.loading = true
      setRegistry(this.form)
        .then(async(res) => {
          if (window.fbq) {
            fbq('track', 'CompleteRegistration');
          }
          if (window.ttq) {
            ttq.track('CompleteRegistration');
            ttq.track('ClickButton')
            ttq.track('Contact')
            ttq.track('AddToCart')
          }
          const token = res.suid
          // await commit('SET_TOKEN', token)
          await this.$store.commit('user/SET_TOKEN', token)
          // this.$store.state.token = token
          setToken(token)
          this.$toast('注册登录成功')
          this.$emit('closeLogin')
          // const getUTokenRes = await getUToken()
          // const logintoken = getUTokenRes.logintoken
          // this.form.logintoken = logintoken
          // this.$store
          //   .dispatch('user/login', this.form)
          //   .then((res) => {
          //     if (window.fbq) {
          //       fbq('track', 'CompleteRegistration');
          //     }
          //     this.$toast('注册登录成功')
          //     this.$emit('closeLogin')
          //   })
        })
        .catch((e) => {
          this.showCaptcha = false
          this.$nextTick(() => {
            this.disabled = true
            this.setCaptcha()
          })
          this.$toast.fail(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less">

.registry {
  background-color: rgba(32,42,67,1);
  border-radius: 30px;
  // height: 814px;
  .close-icon{
      position: absolute;
      // top: 24px;
      // right: 24px;
      bottom: -92px;
      left: calc(50% - 26px);
      z-index: 9;
      height: 52px;
      width:52px;
      background: url(~@/assets/portal/auth/icon_close.svg);
      background-size: 100% 100%;
  }
  .submit_btn{
    height: 88px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    color: var(--btn-text-color);
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    // border: none;
    background: var(--button-home-popup-login);
    // border-radius: 12px;
    // background-color: transparent;
    // border-color:var(--btn-bg-border-color);
    // box-shadow: var(--btn-bg-box-shadow);
    // border-width: 0.5px;
    // border-style: solid;
    // border-radius: 64px;
  }
  .cell_icon1{
    height: 40px;
    width: 40px;
    background: url(~@/assets/portal/auth/icon_账号.svg);
    margin: 24px 0 24px 28px;
  }
  .cell_icon2{
    height: 40px;
    width: 40px;
    background: url(~@/assets/portal/auth/icon_密码.svg);
    margin: 24px 0 24px 28px;
  }
  .cell_icon4{
    height: 40px;
    width: 40px;
    background: url(~@/assets/portal/auth/icon_邀请码.png);
    background-size: 100% 100%;
    margin: 24px 0 24px 28px;
  }
  .invite-code-wrap{
    position: relative;
    margin-top: 32px;
    .invite-code-field.van-cell{
      margin-top: 0;
      border-color: rgba(255,255,255,0.14);
    }
    .invite-code-field .van-field__control{
      color: rgba(255,255,255,0.5);
    }
    .invite-code-placeholder{
      position: absolute;
      left: 78px;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      pointer-events: auto;
      z-index: 1;
      .invite-code-text{
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 28px;
        color: #FFFFFF;
        font-weight: 400;
        line-height: 40px;
      }
      .invite-optional-tag{
        margin-left: 12px;
        padding: 0 12px;
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        background: rgba(255,255,255,0.16);
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: rgba(255,255,255,0.75);
        text-align: center;
        font-weight: 400;
        white-space: nowrap;
      }
    }
  }
  .content{
    border-radius: 12px;
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 116px 40px 48px 40px;
    .header__title {
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 48px;
      font-weight: 600;
    }
    .notice-line{
      display: flex;
      color: #fff;
      margin-top: 30px;
      // margin-bottom: 30px;
      font-size: 28px;
      font-weight: 400;
      font-family: PingFangSC-Regular;
      .main{
        color:  var(--text-color);
      }
    }
    .other{
      font-size: 3vw;
      color: #999;
      text-align: center;
      margin: 2.4vh 0 2vh 0;
    }
  }
  .form {
    // width: 70vw;
    // background: red;
    // padding: 24px;
    margin-top: 2.4vh;
  }
  .van-form .van-button__text{
    font-size: 30px !important;
  }
  //  .van-icon{
  //   margin-right: 5vw;
  // }
  // .van-field__error-message{
  //   text-align: center;
  // }
}
</style>
